import { FormControl, FormLabel, Select, SelectProps, Text } from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { Select as BarteSelect } from "barte-design-system";
interface ListSelectorProps extends SelectProps {
  label?: string;
  options: any[];
  name: string;
  defaultValue?: any;
  dataUserCard?:any;
  placeholder: string;
  register?: any;
  errors?: any
  setDataUserSelectCard?: Dispatch<SetStateAction<string>>;
  dataUserSelectCard?: string;
  showValueText?: boolean;
}

export const ListSelector = ({
  label,
  options,
  name,
  placeholder = "",
  register,
  defaultValue,
  dataUserCard,
  errors,
  dataUserSelectCard,
  setDataUserSelectCard,
  showValueText = false,
  ...rest
}: ListSelectorProps) => {
  return (
    <FormControl isInvalid={!!errors?.message}>

      <FormLabel fontSize=".8rem" marginBottom=".2rem">
        {label}
      </FormLabel>

      <BarteSelect
        options={options}
        onChange={(value) => setDataUserSelectCard(value)}
        placeholder={placeholder}
        value={dataUserSelectCard}
      />

      {errors && (
        <Text fontSize=".8rem" color="danger" mb="4" role="alert">
          {errors?.message}
        </Text>
      )}
    </FormControl>
  );
};
